import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceType } from '../types';
import { DebugState } from './types';

const initialState: DebugState = {
  activeWorkflowPrediction: null,
  cursor: null,
  entity: null,
  externalId: null,
  workflowPredictions: [],
};

export default createSlice({
  name: SliceType.XRayDebug,
  initialState,
  selectors: {
    selectActiveWorkflowPrediction: (state) => state.activeWorkflowPrediction,
    selectCursor: (state) => state.cursor,
    selectEntity: (state) => state.entity,
    selectExternalId: (state) => state.externalId,
    selectWorkflowPredictions: (state) => state.workflowPredictions,
  },
  reducers: {
    reset: (state) => {
      state.activeWorkflowPrediction = initialState.activeWorkflowPrediction;
      state.cursor = initialState.cursor;
      state.entity = initialState.entity;
      state.externalId = initialState.externalId;
      state.workflowPredictions = initialState.workflowPredictions;
    },
    setActiveWorkflowPrediction: (
      state,
      action: PayloadAction<DebugState['activeWorkflowPrediction']>,
    ) => {
      state.activeWorkflowPrediction = action.payload;
    },
    setCursor: (state, action: PayloadAction<DebugState['cursor']>) => {
      state.cursor = action.payload;
    },
    setEntity: (state, action: PayloadAction<DebugState['entity']>) => {
      state.entity = action.payload;
    },
    setExternalId: (state, action: PayloadAction<DebugState['externalId']>) => {
      state.externalId = action.payload;
    },
    setWorkflowPredictions: (
      state,
      action: PayloadAction<DebugState['workflowPredictions']>,
    ) => {
      state.workflowPredictions = action.payload;
    },
  },
});
